import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

import { GET_SUPPORT_REQUESTS } from './get-support-requests.hook';
import { ALLOWED_SUPPORT_REQUEST_CREATION } from './allowed-support-request-creation.hook';

export const UPDATE_SUPPORT_REQUEST = gql`
  mutation ($payload: UpdateSupportRequestInput!) {
    updateSupportRequest(payload: $payload) {
      _id
    }
  }
`;

export const useUpdateSupportRequest = () => {
  const { t } = useTranslation(['supportRequests', 'common']);
  const { t: globalExceptionsT } = useTranslation('common', { keyPrefix: 'exceptions' });

  const [updateSupportRequest] = useMutation(UPDATE_SUPPORT_REQUEST, {
    refetchQueries: [GET_SUPPORT_REQUESTS, ALLOWED_SUPPORT_REQUEST_CREATION],
    onCompleted: () =>
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.success,
        message: t('supportRequests:notifications.success.updated'),
      }),

    onError: (error: any) =>
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: globalExceptionsT('internalError'),
        ...(error && { description: error.errorMessage }),
      }),
  });

  return updateSupportRequest;
};
